module.exports = __webpack_public_path__ + "img/maps_click.46c569ac.svg";